import { Map } from 'immutable';
import actions from './actions';

const initJson = {
  loading: 0,
  generalInfos: {
    'numberOfClinics': null,
    'numberOfUsers': null,
    'numberOfPatients': null,
    'totalFileSize': null,
    'uploadsDirectorySize': null,
    'temporaryDirectorySize': null
  },
  clinicsWithMostPatients: [],
  usersWithMostPatients: [],
  backgroundLogs: [],
  generalLogs: [],
  clinicsData: [],
  databasesData: [],
  backupsData: [],
  logsData: [],
  clinicDetails: {},
  userDetails: {},
  userPermissions: [],
  userAuditLogs: [],
  userBackgroundJobs: [],
  clinicBackgroundJobs: [],
  backupFilter: "",
  userNames: [],
  clinicNames: [],
  dailyStatistics: [],
  weeklyStatistics: [],
  availablePermission: {
    isLoaded:false,
    isLoading:false,
    items:[]
  }
};
const initState = new Map(initJson);

const getMergedDailyStatistics= (existingDailyStatisticsArray, incomingDailyStatistics) => {
  if (!incomingDailyStatistics || !incomingDailyStatistics.length) return existingDailyStatisticsArray;
  incomingDailyStatistics.forEach(incomingDailyStatisticsOfDay=> {
    const indexOfExisting = existingDailyStatisticsArray.findIndex(existing => existing.date === incomingDailyStatisticsOfDay.date);
    if (indexOfExisting > -1) existingDailyStatisticsArray[indexOfExisting] = incomingDailyStatisticsOfDay;
    else existingDailyStatisticsArray.push(incomingDailyStatisticsOfDay);
  });
    
    return existingDailyStatisticsArray.sort((ds1, ds2)=>  (ds1.date > ds2.date) ? 1 : -1);
};

const getMergedWeeklyStatistics= (existingWeeklyStatisticsArray, incomingWeeklyStatisticsOfWeek) => {
  if (!incomingWeeklyStatisticsOfWeek) return;
  const indexOfExisting = existingWeeklyStatisticsArray.findIndex(existing => existing.weekNumber === incomingWeeklyStatisticsOfWeek.weekNumber);
  if (indexOfExisting > -1) existingWeeklyStatisticsArray[indexOfExisting] = incomingWeeklyStatisticsOfWeek;
  else existingWeeklyStatisticsArray.push(incomingWeeklyStatisticsOfWeek);

  return existingWeeklyStatisticsArray.sort((ds1, ds2)=>  (ds1.weekNumber > ds2.weekNumber) ? 1 : -1);
};

export default function authReducer(state = initState, action) {
  const systemInfosCurrentState = state.toJS();
  const reducedLoading = systemInfosCurrentState.loading === 0 ? 0 : systemInfosCurrentState.loading - 1;

  switch (action.type) {

    case actions.GET_CLINIC_NAMES_REQUEST:
    case actions.GET_USER_NAMES_REQUEST:
    case actions.GET_USER_BACKGROUND_JOBS_REQUEST:
    case actions.GET_CLINIC_BACKGROUND_JOBS_REQUEST:
    case actions.GET_USER_AUDIT_LOGS_REQUEST:
    case actions.CHANGE_USER_STATUS_REQUEST:
    case actions.CHANGE_USER_PASSWORD_REQUEST:
    case actions.GET_USER_DETAILS_REQUEST:
    case actions.CREATE_NEW_USER_REQUEST:
    case actions.GET_CLINIC_DETAILS_REQUEST:
    case actions.GET_LOGS_REQUEST:
    case actions.GET_BACKUPS_REQUEST:
    case actions.GET_DATABASES_REQUEST:
    case actions.GET_GENERAL_LOGS_REQUEST:
    case actions.GET_BACKGROUND_LOGS_REQUEST:
    case actions.GET_USERS_WITH_MOST_PATIENTS_REQUEST:
    case actions.GET_CLINICS_WITH_MOST_PATIENTS_REQUEST:
    case actions.GET_GENERAL_INFOS_REQUEST:
    case actions.GET_DAILY_STATISTICS_FOR_DAY_REQUEST:
    case actions.GET_DAILY_STATISTICS_FOR_PERIOD_REQUEST:
    case actions.GET_WEEKLY_STATISTICS_REQUEST:
      return new Map({
        ...systemInfosCurrentState,
        loading: systemInfosCurrentState.loading + 1
      });

    case actions.GET_GENERAL_INFOS_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        generalInfos: action.payload,
        loading: reducedLoading
      });

    case actions.GET_CLINICS_WITH_MOST_PATIENTS_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        clinicsWithMostPatients: action.payload,
        loading: reducedLoading
      });

    case actions.GET_USERS_WITH_MOST_PATIENTS_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        usersWithMostPatients: action.payload,
        loading: reducedLoading
      });

    case actions.GET_BACKGROUND_LOGS_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        backgroundLogs: action.payload,
        loading: reducedLoading
      });

    case actions.GET_GENERAL_LOGS_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        generalLogs: action.payload,
        loading: reducedLoading
      });

    case actions.GET_DATABASES_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        loading: reducedLoading,
        databasesData: action.payload,
      });

    case actions.GET_BACKUPS_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        backupsData: action.payload,
        loading: reducedLoading
      });

    case actions.RESET_LOGS_DATA:
      return new Map({
        ...systemInfosCurrentState,
        logsData: [],
      });
    
    case actions.GET_LOGS_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        logsData: action.payload,
        loading: reducedLoading
      });

    case actions.RESET_CLINICS_DETAILS_DATA:
      return new Map({
        ...systemInfosCurrentState,
        clinicDetails: []
      });
    
    
    case actions.GET_CLINIC_DETAILS_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        clinicDetails: action.payload,
        loading: reducedLoading
      });

    case actions.CREATE_NEW_USER_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        loading: reducedLoading
      });

    case actions.GET_USER_PERMISSIONS_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        userPermissions: action.payload,
        loading: reducedLoading
      });

    case actions.UPDATE_USER_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        loading: reducedLoading
      });

    case actions.GET_USER_DETAILS_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        userDetails: action.payload,
        loading: reducedLoading
      });

    case actions.CHANGE_USER_PASSWORD_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        loading: reducedLoading
      });

    case actions.CHANGE_USER_STATUS_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        loading: reducedLoading
      });

    case actions.RESET_USER_AUDIT_LOGS_DATA:
      return new Map({
        ...systemInfosCurrentState,
        userAuditLogs: []
      });
    
    case actions.GET_USER_AUDIT_LOGS_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        userAuditLogs: action.payload,
        loading: reducedLoading
      });

    case actions.RESET_USER_BACKGROUND_JOBS:
      return new Map({
        ...systemInfosCurrentState,
        userBackgroundJobs: []
      });
    
    case actions.GET_USER_BACKGROUND_JOBS_RSPONSE:
      return new Map({
        ...systemInfosCurrentState,
        userBackgroundJobs: action.payload,
        loading: reducedLoading
      });

      case actions.RESET_CLINIC_BACKGROUND_JOBS:
      return new Map({
        ...systemInfosCurrentState,
        clinicBackgroundJobs: []
      });
    
    case actions.GET_CLINIC_BACKGROUND_JOBS_RSPONSE:
      return new Map({
        ...systemInfosCurrentState,
        clinicBackgroundJobs: action.payload,
        loading: reducedLoading
      });

    case actions.SET_BACKUPS_FILTER:
      return new Map({
        ...systemInfosCurrentState,
        backupFilter: action.filter,
      });

    case actions.GET_CLINIC_NAMES_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        clinicNames: action.payload,
        loading: reducedLoading
      });

    case actions.GET_USER_NAMES_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        userNames: action.payload,
        loading: reducedLoading
      });

    case actions.GET_DAILY_STATISTICS_FOR_DAY_RESPONSE:
    case actions.GET_DAILY_STATISTICS_FOR_PERIOD_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        dailyStatistics: getMergedDailyStatistics(systemInfosCurrentState.dailyStatistics, action.payload),
        loading: reducedLoading
      });
    case actions.GET_WEEKLY_STATISTICS_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        weeklyStatistics: getMergedWeeklyStatistics(systemInfosCurrentState.weeklyStatistics, action.payload),
        loading: reducedLoading
      });
    case actions.GET_AVAILABLE_PERMISSIONS_REQUEST:
      return new Map({
        ...systemInfosCurrentState,
        availablePermission:{
          isLoaded:false,
          isLoading:true,
          items:[]
        }
      });
    case actions.GET_AVAILABLE_PERMISSIONS_RESPONSE:
      return new Map({
        ...systemInfosCurrentState,
        availablePermission:{
          isLoaded:true,
          isLoading:false,
          items:action.payload
        }
      });
    default:
      return state;
  }
}
